import tmhRequest from "@/config/tmhRequest";

export default {
  searchStoreConsumeMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchstoreconsumememberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchStoreConsumeMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchstoreconsumememberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchStoreConsumeMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchstoreconsumememberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchemployeeconsumememberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchemployeeconsumememberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchemployeeconsumememberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchBeauticianConsumeMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchbeauticianconsumememberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchBeauticianConsumeMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchbeauticianconsumememberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchBeauticianConsumeMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchbeauticianconsumememberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchdetailconsumememberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchdetailconsumememberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchdetailconsumememberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchListConsumeMemberStatusReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/searchlistconsumememberstatusreport",
      method: "post",
      data: data
    });
  },
  searchMemberAnalysisReportByPage: function(data) {
    return tmhRequest({
      url: "/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage",
      method: "post",
      data: data
    });
  },
  exportConsumeMemberStatusReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusreport/exportconsumememberstatusreport",
      method: "post",
      responseType: "blob",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusreport.js